const initialState = {
  headlineBlogs: [],
  isLoading: null,
  isError: null,
};

export default initialState;
